import apiClient from '../axios.js';

/**
 * 營運報表 API
 */
export const reportsService = {
  /**
   * 取得門市業績報表
   */
  getStoreSalesReport: async (params = {}) => {
    const response = await apiClient.get('/reports/sales', { params });
    return response;
  },

  /**
   * 取得熱賣商品排行
   */
  getProductRanking: async (params = {}) => {
    const response = await apiClient.get('/reports/products', { params });
    return response;
  },

  /**
   * 取得時段分析
   */
  getTimeAnalysis: async (params = {}) => {
    const response = await apiClient.get('/reports/time-analysis', { params });
    return response;
  },

  /**
   * 取得行銷活動成效
   */
  getCampaignPerformance: async (params = {}) => {
    const response = await apiClient.get('/reports/campaigns', { params });
    return response;
  },

  /**
   * 取得 LINE 推播統計
   */
  getLineStats: async (params = {}) => {
    const response = await apiClient.get('/reports/line-stats', { params });
    return response;
  },

  /**
   * 從 LINE Insight API 同步推播統計
   */
  syncLineInsight: async (body = {}) => {
    const response = await apiClient.post('/reports/line-stats/sync', body);
    return response;
  },

  /**
   * 匯出報表
   */
  exportReport: async (params = {}) => {
    const response = await apiClient.get('/reports/export', {
      params,
      responseType: 'blob'
    });
    return response;
  }
};
